/* External Imports */
import { Box, Text } from '@chakra-ui/react';
/* Internal Imports */
/* Components */
/**
 * @param {Object} sectionContent - Data from api
 * @param {Object} region - Data from api
 * @param {Object} lang - Data from api
 */

const DiscoverSplendor = ({ sectionContent }) => {
  const imageContent = sectionContent.find(
    item => item._modelApiKey === 'single_image'
  );
  const titleContent = sectionContent.find(
    item => item.fieldId === 'discover-txt'
  );
  const bodyContent = sectionContent.find(
    item => item.fieldId === 'indian-arts-txt'
  );

  const bgImage = imageContent ? imageContent.image.url : null;
  const mobileBgImage = imageContent ? imageContent.mobileImage.url : null;
  const titleText = titleContent ? titleContent.text : 'Default Title';
  const bodyText = bodyContent
    ? bodyContent.body.value.document.children[0].children[0].value
    : 'Default Body Text';

  return (
    <>
      <Box bgColor={'black'} pb={{ lg: '20', xl: '10rem', '2xl': '12%' }}>
        <Box
          width={'100%'}
          mb={{ base: '-2rem', md: '0' }}
          // marginY={20}
          maxHeight={{ lg: '772px', '2xl': '857px' }}
          height={{ base: '90vh' }}
          backgroundImage={{
            base: `url(${mobileBgImage})`, // Mobile and smaller screens
            md: `url(${bgImage})`, // Medium screens and up
            lg: `url(https://static.sadhguru.org/d/46272/1731230350-splendor1330.png)`, // Large screens and up
            '2xl': `url(${bgImage})`, // Medium screens and up
          }}
          backgroundRepeat={'no-repeat'}
          backgroundPosition={{
            base: 'center', // Center for small screens
            md: 'center center', // Center for medium and up
          }}
          backgroundSize={{
            base: 'contain', // Adjust to show the full image
            md: 'cover', // Cover for medium screens and up
          }}
          position="relative"
        >
          {/* box for description */}
          <Box
            // padding={2}
            paddingY={{ base: '3rem', md: '3.5rem' }}
            // border={"2px solid red"}
            textAlign={{ base: 'center' }}
            display={'flex'}
            flexDirection={{ base: 'column' }}
            justifyContent={'center'}
            alignItems={'center'}
            position="absolute"
            bottom={{ '2xl': '0', lg: '-1.5rem', md: '0', base: '10%' }}
            left="50%"
            transform="translateX(-50%)"
            // marginBottom={'3rem'}
            background={{ base: 'rgba(1, 5, 9, 0.3)', lg: 'none' }}
            width={'100%'}
            zIndex={10}
          >
            <Text
              fontFamily="var(--FedraSerifDisplay-Regular)"
              color={'white'}
              fontSize={{ base: '1.5rem', md: '1.75rem' }}
              // fontWeight={'400'}
              lineHeight={{ base: '1.75rem', md: '2.0625rem' }}
              whiteSpace={{ base: 'nowrap' }}
            >
              {titleText}
            </Text>
            <Text
              fontFamily="var(--FedraSerifDisplay-light)"
              color={'white'}
              fontSize={{ base: '1.75rem', md: '2.75rem' }}
              fontWeight={'700'}
              lineHeight={{ base: '2.0625rem', md: '3.25rem' }}
              // whiteSpace={{ base: 'nowrap' }}
            >
              {bodyText}
            </Text>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default DiscoverSplendor;
